// @flow
import React, { Component, Fragment } from 'react';
import { BaseActions } from 'store/actionCreators';

import './SettingPassword.scss';

type Props = {
  onChangePassword: (password: string) => Promise<any>,
};

type State = {
  password1: string,
  password2: string,
};

class SettingPassword extends Component<Props, State> {
  state = {
    password1: '',
    password2: '',
  };

  onChangePassword1 = (e: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      password1: e.target.value,
    });
  };

  onChangePassword2 = (e: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      password2: e.target.value,
    });
  };

  onConfirm = async () => {
    const { password1, password2 } = this.state;
    if (password1.length < 5 || password2.length < 5) {
      BaseActions.showToast({ type: 'error', message: '6자 이상 입력해주세요.' });
      return;
    }
    if (password1 !== password2) {
      BaseActions.showToast({ type: 'error', message: '비밀번호가 일치 하지 않습니다.' });
      return;
    }
    try {
      await this.props.onChangePassword(password1);
      this.setState({
        password1: '',
        password2: '',
      });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { password1, password2 } = this.state;
    return (
      <div className="SettingPassword">
        <div className="edit-password">
          <div className="password-form">
            <input
              type="password"
              value={password1}
              autoComplete="new-password"
              placeholder="새 비밀번호"
              onChange={this.onChangePassword1}
            />
            <input
              type="password"
              value={password2}
              autoComplete="new-password"
              placeholder="새 비밀번호 확인"
              onChange={this.onChangePassword2}
            />
            <button className="confirm" onClick={this.onConfirm}>
              비밀번호 변경
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default SettingPassword;



// WEBPACK FOOTER //
// ./src/components/settings/SettingPassword/SettingPassword.js